import { observer } from 'mobx-react-lite'
import {
  useDisableGlobalNavigationIndicator,
  useHideGlobalNavbar,
} from '@/features/shell/global-navigation/GlobalNavigationContainer'
import { useDocumentTitle } from '@/hooks/document-title'
import { Outlet, useLoaderData, useParams } from 'react-router'
import {
  Wizard,
  WizardPageSingleColumnLayout,
  WizardTopBar,
  WizardTopBarLogo,
} from '@/components/Wizard'
import { useLightDarkFn } from '@/features/shell/theming/color-scheme-hooks'
import { useRootStore } from '@/contexts/root-store-context'
import { Button } from '@/components/Button'
import { links } from '@/utils/link'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { useActivation } from '@/hooks/view-model-hooks'

export default observer(function MeasureOneAccountType() {
  useHideGlobalNavbar(true)
  useDisableGlobalNavigationIndicator(true)
  useDocumentTitle('Measure one')
  const lightDark = useLightDarkFn()
  const {
    shell: { shellInfo },
  } = useRootStore()
  const { id } = useParams<{ id: string }>()
  const { vm } = useLoaderData<{ vm: JobDetailsViewModel }>()
  useActivation(vm)

  return (
    <Wizard>
      <WizardPageSingleColumnLayout>
        <WizardTopBar
          title="Measure One Experience Type"
          left={
            <WizardTopBarLogo
              src={lightDark(shellInfo.iconUrl, shellInfo.invertedIconUrl)}
              alt={shellInfo.name}
            />
          }
          right={
            <Button
              variant="outline"
              label="Cancel"
              iconLeft="close"
              testId="cancel-button"
              to={links.taxJobInfoGathering(id)}
            />
          }
        />
        <Outlet context={vm} />
      </WizardPageSingleColumnLayout>
    </Wizard>
  )
})
